import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ConfigurationComponent } from './configuration.component';
import { ConfigurationRoutingModule } from './configuration-routing.component';;
import { UserListComponent } from './user-list/user-list.component';
import { OperatoriesComponent } from './operatories/operatories.component';
import { OfficeLocationsComponent } from './office-locations/office-locations.component';
import { ValidValuesComponent } from './valid-values/valid-values.component';
import { ConfirmComponent } from '../../dialog/confirm-dialog/confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { AddNewMsgBoxComponent } from './valid-values/add-new-msg-box/add-new-msg-box.component';
import { DoctorsComponent } from './doctors/doctors.component';
import { ColorSchemesComponent } from './color-schemes/color-schemes.component';
import { DxoItemDraggingModule } from 'devextreme-angular/ui/nested';
import {
  DxColorBoxModule,
  DxBoxModule,
  DxSchedulerModule,
  DxTreeListModule,
  DxDataGridModule,
  DxPopupModule,
  DxListModule,
  DxSelectBoxModule,
  DxTemplateModule,
  DxButtonModule, DxTextBoxModule, DxCheckBoxModule, DxTooltipModule
} from 'devextreme-angular';
import { NonWorkingDaysComponent } from './non-working-days/non-working-days.component';
//import { FlexLayoutModule } from '@angular/flex-layout';
import { DxoSearchPanelModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { ValidValueSelectModule } from '../../tdo-controls/validvalueselect/validvalueselect-module';
import { MatInputModule } from '@angular/material/input';
import { PatientModule } from '../patient/patient.module';
import { ProceduresComponent } from './procedures/procedures.component';
import { ProceduresFormModule } from './procedures/procedures-form/procedures-form.module';
import {ConfirmModule} from '../../dialog/confirm-dialog/confirm.module';
import {MatTreeModule} from '@angular/material/tree';
import {MatSidenavModule} from '@angular/material/sidenav';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatTableModule} from '@angular/material/table';
import {MatSort, MatSortHeader, MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';
import {ColorChromeModule} from 'ngx-color/chrome';
import { TdoConfigurationActionBarComponent } from '../../tdo-controls/common/tdo-configuration-action-bar/tdo-configuration-action-bar.component';
import {DirectivesModule} from '../../directives/directives.module';
import { BusinessHoursComponent } from './business-hours/business-hours.component';
import { ContentAreaComponent } from '../../tdo-controls/common/content-area/content-area.component';
import { DrawDefaultsComponent } from './draw-defaults/draw-defaults.component';
import { FeeDiscountsComponent } from './fee-discounts/fee-discounts/fee-discounts.component';
import {MatRadioModule} from '@angular/material/radio';
import { EnterpriseInformationComponent } from './enterprise-information/enterprise-information.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { DrawingToolsComponent } from './drawing-tools/drawing-tools.component';
import { DrawAdjustmentToolsComponent } from './draw-adjustment-tools/draw-adjustment-tools.component';
import { DrawTextToolsComponent } from './draw-text-tools/draw-text-tools.component';
import { DrawStampToolsComponent } from './draw-stamp-tools/draw-stamp-tools.component';
import { DrawFunctionToolsComponent } from './draw-function-tools/draw-function-tools.component';
import { DrawMagnifyToolsComponent } from './draw-magnify-tools/draw-magnify-tools.component';
import { DrawDetailToolsComponent } from './draw-detail-tools/draw-detail-tools.component';
import { DrawCanvasToolsComponent } from './draw-canvas-tools/draw-canvas-tools.component';
import { TreatmentConfigurationComponent } from './treatment-configuration/treatment-configuration.component';
import { WorkstationsComponent } from './workstations/workstations.component';
import { UserGroupsComponent } from './user-groups/user-groups.component';
import {RolesComponent} from './user-roles/roles.component';
import { UserConfigurationGroupDialogComponent } from './user-list/dialogs/user-configuration-group-dialog/user-configuration-group-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {TextMaskModule} from 'angular2-text-mask';
import { DoctorConfigurationSaveRequirementsDialogComponent } from './doctors/dialogs/doctor-configuration-save-requirements-dialog/doctor-configuration-save-requirements-dialog.component';
import { DoctorConfigurationAfterSaveWarningDialogComponent } from './doctors/dialogs/doctor-configuration-after-save-warning-dialog/doctor-configuration-after-save-warning-dialog.component';
import { TeethCanalsSurfacesComponent } from './teeth/teeth-canals-surfaces/teeth-canals-surfaces.component';
import { PayerIdConfigurationComponent } from './payer-id-configuration/payer-id-configuration.component';
import { OrganizationConfigurationComponent } from './organization-configuration/organization-configuration.component';
import { TaskTypeConfigurationComponent } from './task-type-configuration/task-type-configuration.component';
import { TaskTypeGroupDialogComponent } from './task-type-configuration/task-type-group-dialog/task-type-group-dialog.component';
import { TaskTypeUserDialogComponent } from './task-type-configuration/task-type-user-dialog/task-type-user-dialog.component';
import { ArAccountConfigurationComponent } from './ar-account-configuration/ar-account-configuration.component';
import { EnterpriseConfigurationComponent } from './enterprise-configuration/enterprise-configuration.component';
import { BlankConfigurationComponent } from './blank-configuration.component';
import { PaymentProcessorConfigurationComponent } from './payment-processor-configuration/payment-processor-configuration.component';
import { OrganizationConfigurationDialogComponent } from './organization-configuration/dialogs/organization-configuration-dialog/organization-configuration-dialog.component';
import { PaymentProcessorDeviceDialogComponent } from './payment-processor-configuration/dialogs/payment-processor-device-dialog/payment-processor-device-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MteAutofillComponent } from './teeth/mte-autofill/mte-autofill.component';
import {MtiModule} from '../forms/custom/mti/mti.module';
import { ProbingDepthComponent } from './teeth/probing-depth/probing-depth.component';
import { DiagnosisDifficultyConfigurationComponent } from './forms/diagnosis-difficulty-configuration/diagnosis-difficulty-configuration.component';
import { RecallConfigurationComponent } from './forms/recall-configuration/recall-configuration.component';
import { MenuConfigurationComponent } from './ui/menu-configuration/menu-configuration.component';
import { MenuMasterItemsConfigurationComponent } from './ui/menu-master-items-configuration/menu-master-items-configuration.component';
import { CheckoutProcessorConfigurationComponent } from './checkout-processor-configuration/checkout-processor-configuration.component';
import { ReferralConfigurationComponent } from './referral-configuration/referral-configuration.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { DevicesComponent } from './devices/devices.component';
import { SelectDeviceDlgComponent } from './workstations/select-device-dlg/select-device-dlg.component';
import { CodeForTeethComponent } from './teeth/code-for-teeth/code-for-teeth.component';
import { PaymentMethodConfigurationComponent } from './payment-method-configuration/payment-method-configuration.component';
import { AnesthesiaAutofillConfigComponent } from './anesthesia/anesthesia-autofill-config/anesthesia-autofill-config.component';
//import { AnesthesiaConfigurationComponent } from './anesthesia-configuration/anesthesia-configuration.component';
import { AnesthesiaExplosionConfigComponent } from './anesthesia/anesthesia-explosion-config/anesthesia-explosion-config.component';
import { NotesToFrontSchedulingComponent } from './notes-to-front/notes-to-front-scheduling/notes-to-front-scheduling.component';
import { PresentationFoldersConfigurationComponent } from './ui/presentation-folders-configuration/presentation-folders-configuration.component';
import { ReferralClientSetupComponent } from './referral-configuration/referral-client-setup/referral-client-setup.component';

import { DxTreeViewModule } from 'devextreme-angular';
import { FormattingLabelConfigurationComponent } from './ui/formatting-label-configuration/formatting-label-configuration.component';
import {ClipboardModule} from "@angular/cdk/clipboard";
import { ClaimsProcessorConfigurationComponent } from './claims-processor-configuration/claims-processor-configuration.component';
import { ReportsConfigurationComponent } from './reports-configuration/reports-configuration.component';
import { LetterTemplateListComponent } from './reports-configuration/letter-template-list/letter-template-list.component';
import { FormBuilderComponent } from './forms/form-builder/form-builder.component';
import {MatExpansionModule} from "@angular/material/expansion";
import { ListNewFormattedLabelUsersComponent } from './ui/formatting-label-configuration/list-new-formatted-label-users/list-new-formatted-label-users.component';
import { ADAcodeConfigComponent } from './adacode-config/adacode-config.component';
import { FormBuilderOpenFormComponent } from './forms/form-builder-open-form/form-builder-open-form.component';

@NgModule({
    declarations: [
        ConfigurationComponent, UserListComponent, OperatoriesComponent,
        OfficeLocationsComponent, ValidValuesComponent,
        AddNewMsgBoxComponent, DoctorsComponent, ColorSchemesComponent,
        NonWorkingDaysComponent, ProceduresComponent, BusinessHoursComponent, ContentAreaComponent,
        DrawDefaultsComponent,
        FeeDiscountsComponent,
        EnterpriseInformationComponent,
        DrawingToolsComponent,
        DrawAdjustmentToolsComponent,
        DrawTextToolsComponent,
        DrawStampToolsComponent,
        DrawFunctionToolsComponent,
        DrawMagnifyToolsComponent,
        DrawDetailToolsComponent,
        DrawCanvasToolsComponent,
        TreatmentConfigurationComponent,
        WorkstationsComponent,
        RolesComponent,
        UserGroupsComponent,
        UserConfigurationGroupDialogComponent,
        DoctorConfigurationSaveRequirementsDialogComponent,
        DoctorConfigurationAfterSaveWarningDialogComponent,
        TeethCanalsSurfacesComponent,
        PayerIdConfigurationComponent,
        OrganizationConfigurationComponent,
        TaskTypeConfigurationComponent,
        TaskTypeGroupDialogComponent,
        TaskTypeUserDialogComponent,
        ArAccountConfigurationComponent,
        EnterpriseConfigurationComponent,
        BlankConfigurationComponent,
        PaymentProcessorConfigurationComponent,
        OrganizationConfigurationDialogComponent,
        PaymentProcessorDeviceDialogComponent,
        MteAutofillComponent,
        ProbingDepthComponent,
        DiagnosisDifficultyConfigurationComponent,
        RecallConfigurationComponent,
        MenuConfigurationComponent,
        MenuMasterItemsConfigurationComponent,
        CheckoutProcessorConfigurationComponent,
        ReferralConfigurationComponent,
        DevicesComponent,
        SelectDeviceDlgComponent,
        CodeForTeethComponent,
        PaymentMethodConfigurationComponent,
        AnesthesiaAutofillConfigComponent,
        //AnesthesiaConfigurationComponent,
        AnesthesiaExplosionConfigComponent,
        NotesToFrontSchedulingComponent,
        PresentationFoldersConfigurationComponent,
        ReferralClientSetupComponent,
        FormattingLabelConfigurationComponent,
        ClaimsProcessorConfigurationComponent,
        ReportsConfigurationComponent,
        LetterTemplateListComponent,
        FormBuilderComponent,
        ListNewFormattedLabelUsersComponent,
        ADAcodeConfigComponent,
        FormBuilderOpenFormComponent,
    ],
  imports: [
    FormsModule,
    ProceduresFormModule,
    ConfigurationRoutingModule,
    MatDialogModule,
    DxColorBoxModule,
    DxBoxModule,
    DxTreeViewModule,
    ValidValueSelectModule,
    ConfirmModule,
    PatientModule,
    MatCheckboxModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatTabsModule,
    MatTableModule,
    //DxTreeListModule,
    DxoSearchPanelModule,
    DxoSelectionModule,
    DxSelectBoxModule,
    MatInputModule,
    MatGridListModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    DxDataGridModule,
    DxPopupModule,
    DxListModule,
    DxoItemDraggingModule,
    MatMenuModule,
    DxSchedulerModule,
    //FlexLayoutModule,
    MatTreeModule,
    MatSidenavModule,
    TdoControlsModule,
    MatSortModule,
    MatTooltipModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    ColorChromeModule,
    DirectivesModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    TextMaskModule,
    DragDropModule,
    MtiModule,
    MatButtonToggleModule,
    CommonModule,
    ClipboardModule,
    MatExpansionModule,
    DxTemplateModule,
    DxButtonModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTooltipModule
  ],
    providers: [],
  exports: [ConfigurationComponent, DoctorsComponent, OrganizationConfigurationComponent]
})
export class ConfigurationModule { }
